module.exports = __webpack_public_path__ + "img/icon_successful@2x.8c2e4ecb.png";